import httpManager from "@/app/shared/utils/httpManager";
/**
 * Obtener todos los usuarios registrados.
 *
 * @return {Promise<Array>} Lista de usuarios.
 */
export default async function (id) {
  const response = await httpManager.get(`/beexai/validations/${id}/queue/`);
  return response?.data;
}
